import { makeSpeciesOptions, SpeciesType } from 'app/constants/species';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Dropdown } from 'semantic-ui-react';

type SpeciesListProps = {
  placeholderIntlId?: string;
  value?: string;
} & (
  | {
      onChange: (specie: SpeciesType | 'all') => void;
      showAll: true;
    }
  | {
      onChange: (specie: SpeciesType) => void;
      showAll: false;
    }
);

export default function SpeciesListDropdown({
  onChange,
  showAll = false,
  value,
  placeholderIntlId,
}: SpeciesListProps) {
  const intl = useIntl();
  const options = useMemo(
    () =>
      [
        showAll
          ? {
              value: 'all',
              label: intl.formatMessage({ id: 'components.dropdown.species-list.specie.all' }),
            }
          : null,
        ...makeSpeciesOptions(intl),
      ].map(({ value, label }) => ({ key: value, text: label, value })),
    [intl, showAll]
  );

  return (
    <Dropdown
      value={value}
      onChange={(_, data) => onChange(data.value as SpeciesType)}
      options={options}
      selection
      placeholder={placeholderIntlId && intl.formatMessage({ id: placeholderIntlId })}
    />
  );
}
